export enum SurveyAnswerCompletedByEnum {
    byUser = 'by user',
    Manual = 'manual',
  }
  